import { asField, BasicTextArea } from 'informed';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import './styles/formFieldStyles.css';

const CustomTextArea = asField(({ className, ...props }) => {
  const { field, fieldState } = props;
  const { error, value, touched } = fieldState;
  const statusClass =
    value && !error && touched ? 'success' : value && error && 'error';

  return (
    <Fragment>
      <BasicTextArea
        {...props}
        aria-invalid={!!error}
        className={`custom-field ${statusClass || ''} ${className || ''}`}
        id={field}
      />
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>
  );
});

CustomTextArea.defaultProps = {
  className: '',
  type: 'text',
};

CustomTextArea.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default CustomTextArea;
